/**
 * Login-method labels and the generic auth failure copy.
 *
 * Split out of `src/app/auth/constants.js` on 2026-08-19: `src/stores/auth.ts` needed these two
 * literals and 1256 dom specs reach that store, so each of them parsed a 1192-line feature
 * constants module for a label lookup and one error string. `app/auth/constants` re-exports both,
 * so the auth views are unchanged.
 */
export const LoginMethodLabel = {
  any: 'All Enabled',
  oauth: 'Google OAuth',
  sso: 'Single Sign-On',
  email_password: 'Email & Password',
  oauth_only: 'Google OAuth Only',
  sso_only: 'Single Sign-On Only',
  email_password_only: 'Email & Password Only',
} as const;

export const defaultErrorMessage = 'Something went wrong, please try again.';

/**
 * Mixpanel event fired once secondary identity data lands after any successful login.
 *
 * Lives here, not only on `AuthEventTracker.EVENT_NAMES`, so `src/stores/auth.ts` can emit it
 * without importing the tracker: that pulled the whole `utils/analytics/tracking` chain into all
 * 1256 dom specs reaching the auth store, for one passthrough call.
 */
export const LOGGED_ON_EVENT = 'Logged on';
